module.exports = ['daily', 'weekly', 'monthly'];
